import { useTranslation } from "react-i18next";
import { Crown } from "lucide-react";
import CeoOverviewTab from "../components/crm/CeoOverviewTab";

export default function TableauCeo() {
  const { t } = useTranslation();
  return (
    <div className="space-y-6" data-testid="ceo-page">
      <div className="dash-card relative overflow-hidden p-6 sm:p-8" data-testid="ceo-page-header">
        <span className="crm-aurora -left-16 -top-20 h-56 w-56" style={{ background: "radial-gradient(circle,rgba(251,191,36,0.45),transparent 70%)" }} />
        <span className="crm-aurora right-10 -top-24 h-52 w-52" style={{ background: "radial-gradient(circle,rgba(234,179,8,0.35),transparent 70%)", animationDelay: "-4s" }} />
        <div className="relative">
          <div className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold border border-amber-400/20" style={{ color: "#fbbf24", background: "rgba(251,191,36,0.14)" }}>
            <Crown className="h-3.5 w-3.5" /> {t("nav.ceoDashboard")}
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter mt-3">
            <span style={{ background: "linear-gradient(120deg,#fbbf24,#f59e0b,#a78bfa)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>{t("crm.ceo.title")}</span>
          </h1>
          <p className="text-muted-foreground mt-2 text-sm sm:text-base max-w-2xl">{t("crm.ceo.pageSubtitle")}</p>
        </div>
      </div>

      <div className="dash-card p-4 sm:p-6">
        <CeoOverviewTab />
      </div>
    </div>
  );
}
